export default [
  {
    path: '/visitorRealNameRigistration',
    meta: {
      isNoNeedToLogin: true
    },
    component: () => import('@/views/VisitorRealNameRigistration/VisitorRealNameRigistration.vue')
  },
  {
    path: '/visitorRealNameSuccess',
    meta: {
      isNoNeedToLogin: true
    },
    component: () => import('@/views/VisitorRealNameRigistration/VisitorRealNameSuccess.vue')
  }
]
